module.exports = __webpack_public_path__ + "static/src/content/images/processed/600/pierata.5903995.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/600/pierata.jpg
// module id = OK7P
// module chunks = 0